import script from "./HomePageAboutUs.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageAboutUs.vue?vue&type=script&setup=true&lang=js"

import "./HomePageAboutUs.vue?vue&type=style&index=0&id=7389439a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7389439a"]])

export default __exports__